import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const Sas = ({ listData }) => {
  const style = { fontFamily: "sans-serif" };
  return (
    <>
      {listData.allowed ? (
        <Col>
          <CardTitle className="mb-2" style={{ color: "#555b21" }}>
            {listData.title}
          </CardTitle>
          <Card className="mini-stats-wid">
            <CardBody>
              <table className="table table-striped">
                <thead>
                  <tr>
                    {listData.header.map((item) => (
                      <th key={item}>{item}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {listData.data.length > 0 ? (
                    listData.data.map((item, id) => (
                      <tr key={id}>
                        <>
                          <td style={style}>{item.nom}</td>
                          <td style={style}>
                            {item.montant.toLocaleString("fr-FR", {
                              style: "currency",
                              currency: "EUR",
                            })}
                          </td>
                          <td style={style}>{item.transmis_le} </td>
                        </>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={listData.header.length}>
                        Aucune donnée disponible
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Sas;
